import { oneOf } from 'prop-types';
import styled from 'styled-components';

const className = (strings, props) => {
  const classNames = ['menu-label']
    .concat(
      ['color']
        .map((name) => (props[name] ? `has-text-${props[name]}` : null))
        .filter((className) => !!className)
    )
    .concat(
      ['weight']
        .map((name) => (props[name] ? `has-text-weight-${props[name]}` : null))
        .filter((className) => !!className)
    )
    .join(' ');

  return classNames;
};

const MenuLabel = styled.p.attrs((props) => ({
  className: className`${props}`,
}))``;

MenuLabel.propTypes = {
  color: oneOf([
    'white',
    'black',
    'light',
    'dark',
    'primary',
    'info',
    'link',
    'success',
    'warning',
    'danger',
    'black-bis',
    'black-ter',
    'grey-darker',
    'grey-dark',
    'grey',
    'grey-light',
    'grey-lighter',
    'white-ter',
    'white-bis',
  ]),
  weight: oneOf(['light', 'normal', 'medium', 'semibold', 'bold']),
};

MenuLabel.defaultProps = {
  color: undefined,
  weight: undefined,
};

export default MenuLabel;
